<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('pollOptions.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_poll_option')"
                :title="$addLabel('pollOption')"
                @click="openPollOptionModal()"
            />
        </app-page-top-section>

        <app-table
            id="poll-option-table"
            :options="options"
            @action="triggerActions"
        />

        <app-poll-option-modal
            v-if="isPollOptionModalActive"
            v-model="isPollOptionModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('poll-option-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import PollOptionMixin from "../../../Mixins/Pms/PollOptionMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "PollOptions",
    mixins: [PollOptionMixin],
    data() {
        return {
            pollOption: '',
            pollOptionsId: '',
            pollOptions: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isPollOptionModalActive: false,
            confirmationModalActive: false,
        }
    },
    watch: {
        isPollOptionModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openPollOptionModal() {
            this.selectedUrl = '';
            this.isPollOptionModalActive = true;
        },
        triggerActions(row, action, active) {
            this.pollOptionsId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isPollOptionModalActive = true;
            }
            if (action.name === 'view_details') {
                this.selectedUrl = window.location = urlGenerator(`${action.url}/${row.id}`);
            }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
